import * as React from 'react';
import cx from 'classnames';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import { Checkbox } from "@common/components/checkbox";
import { IInputComponent } from '@modules/fhq-design-tool/types/input-component';
import { getTestAttributes } from '@common/utils/tests';
import { FieldError } from '../field';
import { Flex } from '@common/components/Flex';
import { Hint } from '@common/components/hint';
import { ErrorText } from '@common/components/error-text';

import './conditional-field.styles.scss';

export type ConditionalFieldProps = IInputComponent<boolean> & React.PropsWithChildren<{
  label: string;
  errors?: Array<FieldError>;
  classes?: {
    component?: string;
  };
}>;

export const ConditionalField: React.FC<ConditionalFieldProps> = (props) => {
  const { classes, value, onChange, metadata, disabled, className, label, margin = '12px 0 0 0', children, required, description, errors } = props;

  const handleChangeWithLabel = React.useCallback(() => {
    onChange(!value);
  }, [onChange, value]);

  return (
    <div
      className={cx(
        'FhqDesignToolConditionalField', 
        className
      )}
      style={{ margin }}
    >
      <Flex 
        className="FhqDesignToolConditionalField__label-input-wrapper"
      >
        <Checkbox 
          {...getTestAttributes(MODULE_NAME, metadata.description, 'checkbox')}
          className={cx("FhqDesignToolConditionalField__input", { 'FhqDesignToolConditionalField__input--disabled': disabled })}
          checked={value} 
          onChange={onChange} 
        />
        {label && (
          <div>
            <span 
              className={cx("FhqDesignToolConditionalField__label", { "FhqDesignToolConditionalField__label--disabled": disabled })} 
              onClick={disabled ? undefined : handleChangeWithLabel}
            >
              {label}{" "}
              {required && <span className="FhqDesignToolConditionalField__required-mark">*</span>}
              {description && <Hint className="FhqDesignToolConditionalField__description-mark" description={description} />}
            </span>
            <div
              className={cx(
                "FhqDesignToolConditionalField__component", 
                { "FhqDesignToolConditionalField__component--disabled": disabled || !value },
                classes?.component,
              )}
            >
              {children}
            </div>
          </div>
        )}
      </Flex>

      {errors?.map((error, i) => (
        <ErrorText
          withTopGap
          text={error.text} 
          key={typeof error.text === 'string' ? error.text : i} 
        />
      ))}
    </div>
  );
};